import { io } from "socket.io-client";
import { API_URL } from "./config";

let socket = null;
const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

/**
 * initSocket - initializes and returns singleton socket instance
 * @param {string} token - JWT token
 * @param {string} url - socket server url (REACT_APP_SOCKET_URL)
 */
export function initSocket(token, url) {
  if (socket) return socket;
  if (!url) {
    url = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL || API_URL;
  }
  socket = io(trimTrailingSlash(url), {
    auth: { token },
    transports: ["websocket", "polling"],
    autoConnect: true,
  });
  

  socket.on("connect_error", (err) => {
    console.error("Socket connect_error", err.message || err);
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
